import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';

const Breadcrumb = () => {
  const location = useLocation();
  const { i18n } = useTranslation();

  // แปลง path เป็น breadcrumb items
  const pathnames = location.pathname.split('/').filter((x) => x);

  // แมป path กับชื่อภาษาไทย/อังกฤษ
  const pathMap = {
    'activity-map': i18n.language === 'en' ? 'Activity Map' : 'แผนที่กิจกรรม',
    'activities': i18n.language === 'en' ? 'Activities' : 'กิจกรรม',
    'donate': i18n.language === 'en' ? 'Donate' : 'บริจาค',
    'donors': i18n.language === 'en' ? 'Donors' : 'รายชื่อผู้บริจาค',
    'contact': i18n.language === 'en' ? 'Contact' : 'ติดต่อเรา',
    'activity': i18n.language === 'en' ? 'Activity Detail' : 'รายละเอียดกิจกรรม'
  };

  // ถ้าอยู่ที่หน้าแรกไม่ต้องแสดง breadcrumb
  if (pathnames.length === 0 || (pathnames.length === 1 && pathnames[0] === 'activity-map')) {
    return null;
  }

  // สร้าง JSON-LD Breadcrumb Schema
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": i18n.language === 'en' ? 'Home' : 'หน้าแรก',
        "item": "https://mirror-foundation-bytony.com/"
      },
      ...pathnames.map((name, index) => ({
        "@type": "ListItem",
        "position": index + 2,
        "name": pathMap[name] || decodeURIComponent(name),
        "item": `https://mirror-foundation-bytony.com/${pathnames.slice(0, index + 1).join('/')}`
      }))
    ]
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>
      </Helmet>

      <nav
        aria-label="breadcrumb"
        style={{
          padding: '1rem 0',
          fontSize: '0.9rem',
          color: '#64748b'
        }}
      >
        <ol
          style={{
            display: 'flex',
            listStyle: 'none',
            padding: 0,
            margin: 0,
            flexWrap: 'wrap',
            gap: '0.5rem',
            alignItems: 'center'
          }}
        >
          <li>
            <Link
              to="/"
              style={{
                color: '#2563eb',
                textDecoration: 'none',
                fontWeight: '500'
              }}
              onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
              onMouseOut={(e) => e.target.style.textDecoration = 'none'}
            >
              {i18n.language === 'en' ? '🏠 Home' : '🏠 หน้าแรก'}
            </Link>
          </li>

          {pathnames.map((name, index) => {
            const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
            const isLast = index === pathnames.length - 1;
            const displayName = pathMap[name] || decodeURIComponent(name);

            return (
              <React.Fragment key={routeTo}>
                <li style={{ color: '#cbd5e1' }}>›</li>
                <li>
                  {isLast ? (
                    <span
                      style={{
                        color: '#1e293b',
                        fontWeight: '600'
                      }}
                    >
                      {displayName}
                    </span>
                  ) : (
                    <Link
                      to={routeTo}
                      style={{
                        color: '#2563eb',
                        textDecoration: 'none',
                        fontWeight: '500'
                      }}
                      onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
                      onMouseOut={(e) => e.target.style.textDecoration = 'none'}
                    >
                      {displayName}
                    </Link>
                  )}
                </li>
              </React.Fragment>
            );
          })}
        </ol>
      </nav>
    </>
  );
};

export default Breadcrumb;
